var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgXBlack = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 25,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M14.888 10.162 24.129 0h-2.19l-8.024 8.824L7.505 0H.114l9.692 13.343L.113 24h2.19l8.475-9.318L17.546 24h7.393zm-3 3.299-.982-1.329L3.093 1.56h3.363l6.306 8.532.982 1.329 8.196 11.09h-3.364z"
})));
export default SvgXBlack;